import actions from '../../actionTypes';

export default () => {
  return {
    type: actions.EXPORTED_TAG_LIST
  };
};


// WEBPACK FOOTER //
// ./src/reducers/tags/actions/downloadedTagList.js